import script from "./IntegrationWorkflow.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationWorkflow.vue?vue&type=script&setup=true&lang=js"

import "./IntegrationWorkflow.vue?vue&type=style&index=0&id=b5bb385c&lang=scss&scoped=true"
import "./IntegrationWorkflow.vue?vue&type=style&index=1&id=b5bb385c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5bb385c"]])

export default __exports__